import { Component, OnDestroy, OnInit, inject } from '@angular/core';

import { RouterOutlet, RouterLink, RouterLinkActive, Router } from '@angular/router';
import { AuthService } from '../../../core/services/auth.service';
import { AuthStateService } from '../../../core/services/auth-state.service';
import { SocketService } from '../../../core/services/socket.service';
import { NavigationAvailabilityService } from '../../../core/services/navigation-availability.service';
import { PageTitleService } from '../../../core/services/page-title.service';

@Component({
    selector: 'app-full-layout',
    imports: [RouterOutlet, RouterLink, RouterLinkActive],
    templateUrl: './full-layout.component.html'
})
export class FullLayoutComponent implements OnInit, OnDestroy {
  private authService = inject(AuthService);
  private authState = inject(AuthStateService);
  private socketService = inject(SocketService);
  private navigation = inject(NavigationAvailabilityService);
  private router = inject(Router);
  readonly pageTitle$ = inject(PageTitleService).title$;

  isConfiguredQR = false;
  isCounselable = false;
  reservationGlobalFlag = false;
  navigationLoading = false;
  navigationUnavailable = false;
  private alive = true;

  async ngOnInit(): Promise<void> {
    await this.loadNavigation();
  }
  async loadNavigation(): Promise<void> {
    if (this.navigationLoading) return;
    this.navigationLoading = true;
    const owner = this.authState.currentMember?.['id'] ?? this.authState.currentMember?.memberId;
    try {
      const state = await this.navigation.load();
      if (!this.alive || owner !== (this.authState.currentMember?.['id'] ?? this.authState.currentMember?.memberId)) return;
      this.isConfiguredQR = state.qr === true;
      this.isCounselable = state.counsel === true;
      this.reservationGlobalFlag = state.reservation === true;
      this.navigationUnavailable = Object.values(state).some(value => value === null);
    } finally { this.navigationLoading = false; }
  }
  ngOnDestroy(): void { this.alive = false; }

  clearSession(): void {
    this.authState.clearSession();
  }

  closeSidebarAfterNavigation(): void {
    this.clearSession();
    this.closeSidebar();
  }

  async logout(): Promise<void> {
    this.closeSidebar();
    // Close our socket first so the server-pushed 'destroy' handler cannot race this
    // navigation with its own.
    this.socketService.disconnect();
    await this.authService.logout();
    const navigated = await this.router.navigate(['/login']).catch(() => false);
    // Never leave the user on an authenticated URL after logout.
    if (!navigated) window.location.assign('/login');
  }

  goBack(): void {
    window.history.back();
  }

  toggleSidebar(): void {
    document.body.classList.toggle('sidebar-hidden');
    if (document.body.classList.contains('sidebar-hidden')) {
      document.getElementById('side-nav-backdrop')?.remove();
    } else {
      const backdrop = document.createElement('div');
      backdrop.id = 'side-nav-backdrop';
      backdrop.className = 'modal-backdrop fade';
      backdrop.addEventListener('click', () => this.closeSidebar());
      document.body.appendChild(backdrop);
    }
  }

  closeSidebar(): void {
    document.body.classList.add('sidebar-hidden');
    document.getElementById('side-nav-backdrop')?.remove();
  }
}
